import React from "react";
import Button from "../../components/UI/Button/Button";
import styles from "./EmployeeList.module.scss";

const ModalActionButtons = ({ onCancel, onAction, actionLabel }) => {
  return (
    <div className={styles.row}>
      <div className={styles.smallSubmit}>
        <Button styleType="light" onClick={onCancel}>
          Cancel
        </Button>
      </div>
      <div className={styles.smallSubmit}>
        <Button onClick={onAction}>{actionLabel}</Button>
      </div>
    </div>
  );
};

export default ModalActionButtons;
